'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var tlru = require('./utils/tlru.js');

var PQueue = require('p-queue');

var HTTP = require('ipfs-utils/src/http.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var PQueue__default = /*#__PURE__*/_interopDefaultLegacy(PQueue);

var HTTP__default = /*#__PURE__*/_interopDefaultLegacy(HTTP);

var cache = new tlru.TLRU(1000);
var ttl = 60 * 1000;
var Queue = PQueue__default["default"].default ? PQueue__default["default"].default : PQueue__default["default"];
var httpQueue = new Queue({
  concurrency: 4
});

var ipfsPath = function ipfsPath(response) {
  if (response.Path) return response.Path;
  throw new Error(response.Message);
};

function resolveDnslink(_x, _x2) {
  return _resolveDnslink.apply(this, arguments);
}

function _resolveDnslink() {
  _resolveDnslink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fqdn, opts) {
    var resolve;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            resolve = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fqdn) {
                var opts,
                    searchParams,
                    query,
                    _response,
                    response,
                    _args2 = arguments;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                        searchParams = new URLSearchParams(opts);
                        searchParams.set('arg', fqdn);
                        query = searchParams.toString();

                        if (!(!opts.nocache && cache.has(query))) {
                          _context2.next = 7;
                          break;
                        }

                        _response = cache.get(query);
                        return _context2.abrupt("return", ipfsPath(_response));

                      case 7:
                        _context2.next = 9;
                        return httpQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                          var res, query, json;
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return HTTP__default["default"].get('https://ipfs.io/api/v0/dns', {
                                    searchParams: searchParams
                                  });

                                case 2:
                                  res = _context.sent;
                                  query = new URL(res.url).search.slice(1);
                                  _context.next = 6;
                                  return res.json();

                                case 6:
                                  json = _context.sent;
                                  cache.set(query, json, ttl);
                                  return _context.abrupt("return", json);

                                case 9:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        })));

                      case 9:
                        response = _context2.sent;
                        return _context2.abrupt("return", ipfsPath(response));

                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function resolve(_x3) {
                return _ref.apply(this, arguments);
              };
            }();

            return _context3.abrupt("return", resolve(fqdn, opts));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _resolveDnslink.apply(this, arguments);
}

exports.resolveDnslink = resolveDnslink;